import {
  logout,
  refreshToken,
  registeredClientCode,
  getInfoByAnthor,
  getAccessTokenByCodeValue,
  refreshTokenByRelogin,
  changeUser
} from '@/api/login'
import {
  getCodes
} from '@/api/code'
import {
  getToken,
  setToken,
  setExpiresIn,
  removeToken
} from '@/utils/auth'
import {getInfo, refreshUserToken, getMemberPackagesInfo} from "@/api/my";
import { checkUserFeatures } from "@/api/home";
import wechat from "@/utils/wechat";
import { sessionStorageCollection } from "@/utils/stroage";
import { getOrCreateRequest } from "@/utils/requestCache";

const user = {
  state: {
    // 基础信息
    token: getToken(),
    name: '',
    user: null,               // 用户账号
    userId: '',             // 用户id
    avatar: '',             // 用户头像

    // 部门与角色
    deptName: '',
    deptId: sessionStorageCollection.get('deptId') || '', // 当前用户部门id
    roleName: sessionStorageCollection.get('roleName') || '', // 当前角色名称
    roleId: sessionStorageCollection.get('roleId') || '',     // 当前角色id
    deptRoleName: sessionStorageCollection.get('deptRoleName') || '', // 当前部门角色名称
    roleList: [],            // 用户角色+部门机构详细信息
    roles: [],
    permissions: [],

    // 联系方式
    phonenumber: '',

    // 微信相关
    isWechat: "",
    wxChatLoading: false,

    // 会员与套餐
    isSuper: sessionStorageCollection.get('isSuper') === 'true' || false, // 用户是否是会员
    vipPackage: [],         // 当前用户会员套餐列表

    // 家长与子账号
    mainAccountInfo: null,  // 家长登录用户的信息
    hasChildAccount: false, // 是否有子账号（家长账号绑定孩子）

    // 记录与学段
    lastLoginRecord: sessionStorageCollection.get('lastLoginRecord') || '', // 上一次登录用户的信息（userId-deptId-roleId）
    schoolType: sessionStorageCollection.get('schoolType') || '', // 当前用户的学段年级
  },
  mutations: {
    SET_IS_WECHAT (state, isWechat) {
      state.isWechat = isWechat
      localStorage.setItem('h5-isWechat', isWechat)
    },
    SET_LAST_LOGIN_RECORD(state, lastLoginRecord) {
      if (!lastLoginRecord || lastLoginRecord === 'undefined' || lastLoginRecord === 'null') {
        return;
      }
      state.lastLoginRecord = lastLoginRecord
      sessionStorageCollection.set('lastLoginRecord', lastLoginRecord)
    },
    SET_TOKEN: (state, token) => {
      setToken(token);
      state.token = token;
    },
    SET_EXPIRES_IN: (state, time) => {
      state.expires_in = time
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_USER: (state, user) => {
      state.user = user
    },
    SET_USER_ID: (state, userId) => {
      state.userId = userId
    },
    SET_DEPT_NAME: (state, deptName) => {
      state.deptName = deptName
    },
    SET_DEPT_ID: (state, deptId) => {
      state.deptId = deptId
      sessionStorageCollection.set('deptId', deptId)
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_ROLE_LIST: (state, roleList) => {
      state.roleList = roleList
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_PHONE_NUMBER: (state, phoneNumber) => {
      state.phonenumber = phoneNumber
    },
    SET_MAIN_ACCOUNT_INFO: (state, userInfo) => {
      state.mainAccountInfo = userInfo
      sessionStorage.setItem('mainAccountInfo', JSON.stringify(userInfo))
    },
    SET_CHILD_ACCOUNT: (state, hasChildAccount) => {
      state.hasChildAccount = hasChildAccount;
      sessionStorage.setItem('hasChildAccount', JSON.stringify(hasChildAccount))
    },
    SET_WX_CHAT_LOADING: (state, wxChatLoading) => {
      state.wxChatLoading = wxChatLoading;
      sessionStorage.setItem('wxChatLoading', wxChatLoading)
    },
    SET_SCHOOL_TYPE: (state, schoolType) => {
      if (!schoolType) {
        return;
      }
      state.schoolType = schoolType;
      sessionStorageCollection.set('schoolType', schoolType)
    },
    SET_IS_SUPER: (state, isSuper) => {
      state.isSuper = isSuper;
      sessionStorageCollection.set('isSuper', isSuper)
    },
    SET_ROLE_ID: (state, roleId) => {
      state.roleId = roleId;
      sessionStorageCollection.set('roleId', roleId)
    },
    SET_ROLE_NAME: (state, roleName) => {
      state.roleName = roleName;
      sessionStorageCollection.set('roleName', roleName)
    },
    SET_DEPT_ROLE_NAME: (state, deptRoleName) => {
      state.deptRoleName = deptRoleName;
      sessionStorageCollection.set('deptRoleName', deptRoleName)
    },
    SET_VIP_PACKAGE: (state, vipPackage) => {
      state.vipPackage = vipPackage;
    }
  },
  actions: {
    /**登录三步走 start */
    Login({
      commit
    }, userParams) {
      return new Promise((resolve, reject) => {
        registeredClientCode(userParams).then(res => {
          if (res.code == 200) {
            let data = res.data
            let code = data.url.split('=')[1]
            let params = {
              clientId: userParams.clientId,
              // clientSecret: "BvdmQqGIwRXYKTlu",
              clientSecret: "BImGonlWwbsVRn0a", // appId: jpXyGE1L APP端
              authorizationCodeValue: code,
              authorizationGrantType: 'code'
            }

            if (userParams.openId) {
              params.openId = userParams.openId
            }

            getAccessTokenByCodeValue(params).then(result => {
              if (result.code === 200) {
                let tokenData = result.data
                commit('SET_TOKEN', tokenData.accessTokenValue)
                resolve()
              } else {
                reject(result)
              }
            })
          } else {
            reject(res)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    RoleLogin({
            commit
          }, userParams) {
      return new Promise((resolve, reject) => {
        if (!userParams.openId && localStorage.getItem("openId-h5")) {
          userParams.openId = localStorage.getItem("openId-h5");
        }
        refreshTokenByRelogin(userParams).then(res => {
          if (res.code == 200 && res.data && res.data.accessToken) {
            commit('SET_TOKEN', res.data.accessToken);
            wechat._clearAllCache();
            resolve()
          }else {
            reject(res.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    H5RefreshCurrentToken({
            commit
          }) {
      return new Promise((resolve, reject) => {
        refreshUserToken().then(res => {
          if (res.code == 200 && res.data && res.data.accessToken) {
            commit('SET_TOKEN', res.data.accessToken);
            resolve()
          }else {
            reject(res.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RoleLoginUser({
                commit
              }, userParams) {
      return new Promise((resolve, reject) => {
        changeUser(userParams).then(res => {
          console.log("changeUser",res,res.data)
          if (res.code == 200 && res.data && res.data.accessTokenValue) {
            commit('SET_TOKEN', res.data.accessTokenValue);
            wechat._clearAllCache();
            // 清除当前登录角色信息
            localStorage.removeItem('lastLoginRecord')
            localStorage.removeItem('loginRoleId')
            localStorage.removeItem('loginDeptId')
            resolve()
          }else {
            reject(res.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    // TODO 主要获取用户数据方法
    GetProfile({commit, dispatch}) {
      // 使用请求缓存池，避免并发重复请求
      return getOrCreateRequest('Store-User-GetProfile', () => {
        return new Promise( (resolve, reject) => {
          getInfo().then(res => {
            let user = res.data;
            let currentRole = res.currRole;

            commit('SET_USER',user);
            commit('SET_NAME', user.nickName);
            commit('SET_USER_ID', user.userId);
            commit('SET_DEPT_ID', user.deptId);
            commit('SET_SCHOOL_TYPE', user.schoolType);
            commit('SET_PHONE_NUMBER', user.phonenumber);

            // 获取用户角色列表
            if (user.roles) {
              let result = [];
              user.roles.forEach(role => {
                result.push({
                  name: role.roleName,
                  deptName: role.deptName,
                  value: `${role.deptId},${role.roleId}`
                });
              });
              commit('SET_ROLE_LIST', result)
            }

            // dispatch("GetMemberPackagesInfo");

            // 获取当前用户角色
            if(currentRole && currentRole.length > 0) {

              // 存储当前登录角色名称
              commit('SET_ROLE_NAME', currentRole[0].roleName);

              // 存储当前登录角色ID
              commit('SET_ROLE_ID', currentRole[0].roleId);
              
              // 存储当前登录部门角色名称
              commit('SET_DEPT_ROLE_NAME', user.dept.deptName + '-' + currentRole[0].roleName);

              // 存储当前登录角色信息
              commit('SET_LAST_LOGIN_RECORD', user.userId + '-' + user.dept.deptId + '-' + currentRole[0].roleId);
            }

            // 判断是否有子账号 (家长账号绑定孩子)，存储子账号信息。
            if (user.patriarchUser && Object.prototype.hasOwnProperty.call(user.patriarchUser, 'userName')){
              commit('SET_MAIN_ACCOUNT_INFO', user.patriarchUser);
              commit('SET_CHILD_ACCOUNT', !!user.patriarchUser); // 是否有子账号 (家长账号绑定孩子)
            }else {
              commit('SET_MAIN_ACCOUNT_INFO', null);
              commit('SET_CHILD_ACCOUNT', false);
            }

            resolve(res);
          }).catch(error => {
            reject(error)
          })
        })
      });
    },
    // TODO 通过TOKEN获取用户信息，存在数据滞后。目前作为数据初始化使用，后续可以逐步替换
    GetInfo({
      commit,
      state
    }) {
      // 使用请求缓存池，避免并发重复请求
      return getOrCreateRequest('Store-User-GetInfo', () => {
        return new Promise((resolve, reject) => {
          getInfoByAnthor({
            accessTokenValue: state.token
          }).then(res => {
            const user = res.data
            const currentRole = user.roles;

            // commit('SET_USER',user);
            commit('SET_NAME', user.nickName);
            commit('SET_USER_ID', user.userId);
            commit('SET_DEPT_ID', user.deptId);
            commit('SET_PHONE_NUMBER', user.phonenumber);

            // 获取当前用户角色
            if (currentRole && currentRole.length === 1) {

              // 存储当前登录角色名称
              commit('SET_ROLE_NAME', currentRole[0].roleName);

              // 存储当前登录角色ID
              commit('SET_ROLE_ID', currentRole[0].roleId)

              // 存储当前登录部门角色名称
              commit('SET_DEPT_ROLE_NAME', currentRole[0].deptName + '-' + currentRole[0].roleName);

              // 存储当前登录角色信息
              commit('SET_LAST_LOGIN_RECORD', user.userId + '-' + currentRole[0].deptId + '-' + currentRole[0].roleId)
            }

            // 获取用户角色列表
            if (user.roleList) {
              let result = [];
              user.roleList.forEach(role => {
                result.push({
                  name: role.roleName,
                  deptName: role.deptName,
                  value: `${role.deptId},${role.roleId}`
                });
              });
              commit('SET_ROLE_LIST', result)
            }

            // 判断是否有子账号 (家长账号绑定孩子)，存储子账号信息
            if (user.patriarchUser && Object.prototype.hasOwnProperty.call(user.patriarchUser, 'userName')){
              commit('SET_MAIN_ACCOUNT_INFO', user.patriarchUser);
              commit('SET_CHILD_ACCOUNT', !!user.patriarchUser);
            }else {
              commit('SET_MAIN_ACCOUNT_INFO', null);
              commit('SET_CHILD_ACCOUNT', false);
            }

            resolve(res)
          }).catch(error => {
            reject(error)
          })
        })
      });
    },
    /**登录三步走end */

    // 退出系统
    LogOut({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        // logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          commit('SET_IS_SUPER', false) // 清除会员状态
          wechat._clearAllCache();
          localStorage.removeItem("deptId")
          localStorage.removeItem("userId")
          removeToken()
          sessionStorageCollection.remove('schoolType')
          sessionStorageCollection.remove('isSuper')
          sessionStorageCollection.remove('roleName')
          sessionStorageCollection.remove('deptRoleName')
          resolve()
        // }).catch(error => {
        //   reject(error)
        // })
      })
    },

    // 前端 登出
    FedLogOut({
      commit
    }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_IS_SUPER', false) // 清除会员状态
        // 清除会话缓存
        sessionStorageCollection.remove('schoolType')
        sessionStorageCollection.remove('isSuper')
        sessionStorageCollection.remove('roleName')
        sessionStorageCollection.remove('deptRoleName')
        removeToken()
        resolve()
      })
    },

    // 刷新token
    RefreshToken({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        refreshToken(state.token).then(res => {
          setExpiresIn(res.data)
          commit('SET_EXPIRES_IN', res.data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 数据字典
    GetCodes({
      commit
    }, code) {
      return new Promise((resolve, reject) => {
        getCodes(code).then(res => {
          commit('SET_CODES', res.data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    CheckUserFeatures({
      commit
    }) {
      // 使用请求缓存池，避免并发重复请求
      return getOrCreateRequest('Store-User-CheckUserFeatures', () => {
        return new Promise((resolve, reject) => {
          checkUserFeatures().then(res => {
            if (res.code === 200) {
              commit('SET_IS_SUPER', res.data);
              resolve(res.data);
            } else {
              reject(res);
            }
          }).catch(error => {
            reject(error);
          });
        });
      });
    },
    // 获取用户会员套餐信息
    GetMemberPackagesInfo({
      commit
    }) {
      // 使用请求缓存池，避免并发重复请求
      return getOrCreateRequest('Store-User-GetMemberPackagesInfo', () => {
        return new Promise((resolve, reject) => {
          getMemberPackagesInfo().then(res => {
            if (res.code === 200 && res.data) {
              commit('SET_VIP_PACKAGE', res.data);
              resolve(res.data);
            } else {
              commit('SET_VIP_PACKAGE', []);
              resolve([]);
            }
          }).catch(error => {
            commit('SET_VIP_PACKAGE', []);
            reject(error);
          });
        });
      });
    },
    // 统一获取会员信息（包括会员状态和套餐信息）
    GetMemberInfo({
      dispatch
    }) {
      // 使用请求缓存池，避免并发重复请求
      return getOrCreateRequest('Store-User-GetMemberInfo', () => {
        return Promise.all([
          dispatch('CheckUserFeatures'),
          dispatch('GetMemberPackagesInfo')
        ]).then(([isSuper, vipPackage]) => {
          return { isSuper, vipPackage };
        });
      });
    }
  }
}

export default user